import InsuranceCardNumber from './InsuranceCardNumber';

export default InsuranceCardNumber;
export { InsuranceCardNumber };
